/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcheancePaiementListItemDto
 */
export interface EcheancePaiementListItemDto {
    /**
     * Unique identifier of the payment schedule
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    id: string;
    /**
     * Due date of the payment
     * @type {Date}
     * @memberof EcheancePaiementListItemDto
     */
    dueDate: Date;
    /**
     * Date when the withdrawal was made
     * @type {Date}
     * @memberof EcheancePaiementListItemDto
     */
    withdrawalDate?: Date | null;
    /**
     * Payment amount
     * @type {number}
     * @memberof EcheancePaiementListItemDto
     */
    amount: number;
    /**
     * Current status of the payment schedule
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    status: string;
    /**
     * Hex color code for the status badge
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    statusColor?: string | null;
    /**
     * Date when the status was last updated
     * @type {Date}
     * @memberof EcheancePaiementListItemDto
     */
    statusDate?: Date | null;
    /**
     * Last name of the subscriber
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    subscriberLastName?: string;
    /**
     * First name of the subscriber
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    subscriberFirstName?: string;
    /**
     * Name of the product
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    productName?: string;
    /**
     * Contract number
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    contractNumber?: string;
    /**
     * Direct debit key
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    directDebitKey?: string;
    /**
     * Unique mandate reference (RUM)
     * @type {string}
     * @memberof EcheancePaiementListItemDto
     */
    rum?: string;
    /**
     * Number of payment attempts
     * @type {number}
     * @memberof EcheancePaiementListItemDto
     */
    attempts: number;
}

/**
 * Check if a given object implements the EcheancePaiementListItemDto interface.
 */
export function instanceOfEcheancePaiementListItemDto(value: object): value is EcheancePaiementListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    return true;
}

export function EcheancePaiementListItemDtoFromJSON(json: any): EcheancePaiementListItemDto {
    return EcheancePaiementListItemDtoFromJSONTyped(json, false);
}

export function EcheancePaiementListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcheancePaiementListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dueDate': (new Date(json['dueDate'])),
        'withdrawalDate': json['withdrawalDate'] == null ? undefined : (new Date(json['withdrawalDate'])),
        'amount': json['amount'],
        'status': json['status'],
        'statusColor': json['statusColor'] == null ? undefined : json['statusColor'],
        'statusDate': json['statusDate'] == null ? undefined : (new Date(json['statusDate'])),
        'subscriberLastName': json['subscriberLastName'] == null ? undefined : json['subscriberLastName'],
        'subscriberFirstName': json['subscriberFirstName'] == null ? undefined : json['subscriberFirstName'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'contractNumber': json['contractNumber'] == null ? undefined : json['contractNumber'],
        'directDebitKey': json['directDebitKey'] == null ? undefined : json['directDebitKey'],
        'rum': json['rum'] == null ? undefined : json['rum'],
        'attempts': json['attempts'],
    };
}

export function EcheancePaiementListItemDtoToJSON(json: any): EcheancePaiementListItemDto {
    return EcheancePaiementListItemDtoToJSONTyped(json, false);
}

export function EcheancePaiementListItemDtoToJSONTyped(value?: EcheancePaiementListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dueDate': ((value['dueDate']).toISOString()),
        'withdrawalDate': value['withdrawalDate'] == null ? undefined : ((value['withdrawalDate'] as any).toISOString()),
        'amount': value['amount'],
        'status': value['status'],
        'statusColor': value['statusColor'],
        'statusDate': value['statusDate'] == null ? undefined : ((value['statusDate'] as any).toISOString()),
        'subscriberLastName': value['subscriberLastName'],
        'subscriberFirstName': value['subscriberFirstName'],
        'productName': value['productName'],
        'contractNumber': value['contractNumber'],
        'directDebitKey': value['directDebitKey'],
        'rum': value['rum'],
        'attempts': value['attempts'],
    };
}

